import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
/* new imports go here - do not remove or change this line */
import config from './store/reducers/config';
import error from './store/reducers/error';
import { WeakType } from './typescript-migration';

export interface IRootReducer {
  config: WeakType;
  error: WeakType;
  router: WeakType;
}

const rootReducer = history =>
  combineReducers({
    /* new reducers go here - do not remove or change this line */
    config,
    error,
    router: connectRouter(history),
  });

export default rootReducer;
